export enum DOMAuthEvents {
  FORM_AUTH_OPEN = 'form:auth:open',
}
